// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jobsWithPlaylist_root__3bik3 {\n  width: 100%;\n  height: calc(100% - 40px); }\n  .jobsWithPlaylist_root__3bik3 .jobsWithPlaylist_jobs__1tZMx {\n    height: calc(100vh - 225px);\n    overflow: auto;\n    position: relative; }\n\n.jobsWithPlaylist_nextBtn__f5QCK {\n  outline: none;\n  border: none;\n  background: inherit;\n  color: #005cb2;\n  position: absolute;\n  bottom: 6px;\n  left: calc(50% - 40px);\n  cursor: pointer; }\n  .jobsWithPlaylist_nextBtn__f5QCK:hover {\n    color: #6ab7ff; }\n  .jobsWithPlaylist_nextBtn__f5QCK:disabled {\n    color: #6ab7ff;\n    cursor: not-allowed; }\n", ""]);
// Exports
exports.locals = {
	"root": "jobsWithPlaylist_root__3bik3",
	"jobs": "jobsWithPlaylist_jobs__1tZMx",
	"nextBtn": "jobsWithPlaylist_nextBtn__f5QCK"
};
module.exports = exports;
